import { isMagicbuyProject } from '@g/utils/projectUtils'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  send ({ state, commit, rootState }, params) {
    if (params && isMagicbuyProject(rootState.project)) {
      params.site = 'MG'
    }
    return rootState.axios.post('/captcha/v1frontend/captcha/send', params)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
